import api from "./api";

export const notificationService = {
  getAll: () => api.get("/notifications").then((res) => res.data),
  markAsRead: (id) => api.put(`/notifications/${id}/read`).then((res) => res.data),
  markAllRead: () => api.put("/notifications/mark-all-read").then((res) => res.data),
};
